import React from "react";
import "lazysizes";
import { imgURL } from "@/helpers/userHelpers";

const SrcsetPLP = (props) => {
  let { src, alt, className, svgFile, requirePath, lazyLoad, title, retinaImage,dataga4, width, height, isHighDpi, ...otherProps } = props;
  const blur = false; // To enable blur image effect.
  // let srcset = "";
  const plainSrc = src;
  src = src + "&width=" + width*isHighDpi;
  // srcset = srcsetMaker(src,retinaImage);

  if (!src) {
    src =
      "https://cdn.shopify.com/s/files/1/0058/1402/6322/t/1/assets/no-image.png?1522";
      srcset = ""
  }
  if (requirePath) {
    src = process.env.NETLIFY_URL + "/" + src;
  }
  if (svgFile) {
    return (
      <img
        src={src}
        className={className ? className : ""}
        alt={alt}
        {...otherProps}
        loading={lazyLoad ? "lazy" : undefined}
        {...dataga4 ? {"data-ga4" : dataga4}:""}
        title={title}
      />
    );
  }
  return (
    <img
      src={
        blur
          ? imgURL(src, "30x")
          : "data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAQAICRAEAOw=="
      }
      data-srcset={`${plainSrc}&width=${width} ${width}w, ${src} ${width*2}w`}
      srcSet={`${plainSrc}&width=${width} ${width}w, ${src} ${width*2}w`}
      data-sizes="100vw"
      className={`${className ? `${className} lazyload` : "lazyload"}`}
      alt={alt}
      decoding="async"
      {...otherProps}
      loading={lazyLoad ? "lazy" : undefined}
      priority={lazyLoad ? undefined : "true"}
      fetchpriority={lazyLoad ? "low" : "high"}
      title={title}
      width={width}
      height={height}
    />
  );
};



export default SrcsetPLP;
